import axios from "axios";
import { useNavigate } from "react-router";

export const useApi = (props) => {
  const navigate = useNavigate();
  const authInstance = axios.create({
    baseURL: process.env.REACT_APP_AUTH_BACKEND + "/auth",
    withCredentials: true,
    timeout: 1000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  const userInstance = axios.create({
    baseURL: process.env.REACT_APP_AUTH_BACKEND + "/user",
    withCredentials: true,
    timeout: 1000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  const verifyInstance = axios.create({
    baseURL: process.env.REACT_APP_AUTH_BACKEND + "/verify",
    withCredentials: true,
    timeout: 1000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  const pageInstance = axios.create({
    baseURL: process.env.REACT_APP_AUTH_BACKEND + "/pages",
    withCredentials: true,
    timeout: 1000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // const instance = axios.create({
  //   baseURL: process.env.REACT_APP_BACKEND,
  //   withCredentials: true,
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  // });

  const adminInstance = axios.create({
    baseURL: process.env.REACT_APP_AUTH_BACKEND + "/admin",
    withCredentials: true,
    timeout: 1000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  const toastHandler = (data) => {
    if (!data.status) {
      props.showToast("error", data.message);
    } else {
      props.showToast("success", data.message);
    }
  };

  const apiCall = async (method) => {
    let data;
    try {
      const res = await method();
      data = res.data;
    } catch (err) {
      if (err.response.data.message === "Your session is not valid.") {
        authInstance
          .post("/token/reset")
          .then((data) => {})
          .catch((err) => {
            navigate("/login");
          });
        err.response.data.message =
          "Your session was not valid. Please try again.";
      }
      data = err.response.data;
    }

    return data;
  };

  const resetToken = async () => {
    const data = await apiCall(() => authInstance.post("/token/reset"));
    if (!data.status) {
      navigate("/login");
    }
    return data;
  };

  const verifyEmail = async (token) => {
    const data = await apiCall(() => authInstance.get("/verify/email/init"));
    toastHandler(data);
    return data;
  };

  const accessPreSignup = async (values) => {
    const data = await apiCall(() =>
      verifyInstance.post("/request-code", { ...values })
    );
    return data;
  };

  const getUser = async () => {
    const data = await apiCall(() => userInstance.get("/me"));
    return data;
  };

  const getUserData = async () => {
    const data = await apiCall(() => userInstance.get("/data"));
    return data;
  };

  const getPageData = async () => {
    const data = await apiCall(() => pageInstance.get("/"));
    return data;
  };

  const logout = async () => {
    const data = await apiCall(() => authInstance.get("/logout"));
    toastHandler(data);
    if (data.status) {
      navigate("/login");
    }
  };

  const checkAdmin = async () => {
    const data = await apiCall(() => adminInstance.get("/me"));
    if (data.status) {
      navigate("/admin");
    }
    return data;
  };

  return {
    resetToken,
    verifyEmail,
    accessPreSignup,
    getUser,
    logout,
    checkAdmin,
    getUserData,
    getPageData,
  };
};
